import React, { useState, useEffect, useContext } from 'react'

import { Modal, IconButton } from '@paypalcorp/pp-react'
import { MessageFormat } from '@paypalcorp/worldready'
import { Context as WorldReadyContext } from '@paypalcorp/worldready-react'

// components
import { CreateComponent, sessionTimerHoc } from '../../components'
import SubHeader from './sub-header'
import DWSubHeader from './dw-sub-header'
import MerchantSubHeader from './merchant-sub-header'
import PrivacyHub from '../privacyhub/PrivacyHubHome'
import { DSRZettleHome } from '../dsr'
// utils
import { fptiCustomImpression, triggerQualtrics, serverData } from '../../utils'

const { selectedComponent, pageName = 'home', keys = {} } = serverData

const Home = (props) => {
  const {
    children = null,
    isFlow = false,
    showBackButton = false,
    backUrl = '',
    closeUrl = '',
    domid = '',
  } = props
  const { elmoFlags = {}, locality = {} } = serverData
  const directionality = locality.directionality || 'ltr'
  const { xe = '' } = elmoFlags.tracking
  const { xt = '' } = elmoFlags.tracking
  const fptiData = {
    pgrp: `main:dataprivacy:${pageName}`,
    page: `main:dataprivacy:${pageName}`,
    pglk: `main:dataprivacy:${pageName}:data_privacy`,
    xe,
    xt,
  }
  const [modalInfo, setModalInfo] = useState({})
  const [impressionDone, setImpressionDone] = useState(false)
  const [position, setPosition] = useState(0)
  const [modalParams, setModalParams] = useState({})
  const navigateToUrl = (url) => {
    window.location.href = url
  }
  const resetState = () => {
    setModalInfo({})
    const closeBtnClickState = closeUrl
      ? navigateToUrl(closeUrl)
      : setPosition(0)
    return closeBtnClickState
  }
  const worldReady = useContext(WorldReadyContext)

  const onBackButtonClick = (event) => {
    event.preventDefault()
    const backBtnClickState = backUrl
      ? navigateToUrl(backUrl)
      : setPosition(position - 1)
    return backBtnClickState
  }
  const setModalStore = (param) => {
    Object.assign(modalParams, param)
  }
  const onCloseModal = () => resetState()

  const onSectionClick = (modal) => setModalInfo(modal)

  const { slides = [], redirect = '' } = props
  useEffect(() => {
    const { location = {} } = props
    setPosition(props.position)
    setModalParams({})
    const { search = '' } = location
    if (search) {
      triggerQualtrics(search)
    }
    if (!impressionDone) {
      setImpressionDone(true)
      fptiCustomImpression(fptiData)
    }

    if (window) {
      window.onbeforeunload = function () {
        const params = new URLSearchParams(window.location.search)
        if (params && params.has('flow')) {
          let value = params.get('flow')
          if (value === 'dataaccess' || value === 'datadeletion') {
            // This code to block qualtrics intercept from reappearing
            history.replaceState('', '', '/myaccount/privacy')
          }
        }
        return
      }
    }
  }, [])

  const childProps = {
    ...modalInfo,
    position,
    slides,
    redirect,
    modalParams,
    updateModalStore: setModalStore,
    onModalNavigate: setPosition,
  }
  const isModalOpen = isFlow ? true : !!modalInfo.name
  const renderChildren = () => React.Children.map(children, (child) => child)
  const shouldShowBackBtn =
    showBackButton || (position > 0 && position < slides.length - 1)
  const modalComponent = (
    <Modal
      overpanel
      contentClassName="privacy-modal-content"
      headerClassName="privacy-modal-header"
      isOpen={isModalOpen}
      onClose={onCloseModal}
      style={{ direction: directionality }}
      id={domid || modalInfo.name || ''}
      action={
        shouldShowBackBtn && (
          <IconButton
            onClick={onBackButtonClick}
            href="/"
            as="a"
            id="backIconButton"
            className="back-icon-button"
            iconName="arrow-left"
            size="sm"
            aria-label={new MessageFormat(worldReady, {
              id: `app.navigation.backLink`,
            }).format()}
          />
        )
      }
      closeOnBackgroundClick={isFlow ? false : true}
    >
      {(isFlow && slides.length && <CreateComponent {...childProps} />) ||
        (isFlow && renderChildren()) || <CreateComponent {...childProps} />}
    </Modal>
  )

  const PrivacyComponents = {
    default: (
      <div>
        <SubHeader onSectionClick={onSectionClick} /> {modalComponent}
      </div>
    ),
    merchant: (
      <div>
        <MerchantSubHeader onSectionClick={onSectionClick} /> {modalComponent}
      </div>
    ),
    dw2: (
      <div>
        <DWSubHeader onSectionClick={onSectionClick} /> {modalComponent}
      </div>
    ),
    privacyhub: (
      <>
        <PrivacyHub onSectionClick={onSectionClick} keys={keys} {...props} />{' '}
        {modalComponent}
      </>
    ),
    zettle: (
      <div className="zettleContainer">
        <DSRZettleHome onSectionClick={onSectionClick} keys={keys} {...props} />{' '}
      </div>
    ),
  }

  const componentToRender = isFlow ? (
    modalComponent
  ) : (
    <div data-testid="home-page">
      {!selectedComponent
        ? PrivacyComponents.default
        : PrivacyComponents[selectedComponent]}
    </div>
  )

  return componentToRender
}

export default sessionTimerHoc(Home)
